import ValueGeneratorInterface from "./ValueGeneratorInterface"
import ConstantValue from "../../Model/Value/ConstantValue"

export type ConstantDefinition = {
  value: number
  symbol: string
  range: [number, number]
}

export default class ConstantValueGenerator implements ValueGeneratorInterface {
  constructor(private readonly definitions: ConstantDefinition[]) {}
  public supports(value: number): boolean {
    return this.definitions.some(
      (definition: ConstantDefinition): boolean =>
        value >= definition.range[0] && value <= definition.range[1],
    )
  }

  public generate(value: number): ConstantValue {
    const definition: ConstantDefinition = this.definitions.find(
      (definition: ConstantDefinition): boolean =>
        value >= definition.range[0] && value <= definition.range[1],
    )!

    return new ConstantValue(definition.value, definition.symbol)
  }
}
